import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  tabSwitch: {
    event_name: 'account_tab_switch',
    event_category: 'account',
    event_action: null, // account_tab_switched
    event_label: null, // selected tab value
  },

  orderDetails: {
    event_name: 'account_view_details',
    event_category: 'account',
    event_action: null, // selected_view_details
    event_label: null, // view details
  },

  orderItem: {
    event_name: 'account_view_item',
    event_category: 'account',
    event_action: null, // selected_view_item
    event_label: null, //view item
  },

  profileUpdate: {
    event_name: 'profile_update',
    event_category: 'account',
    event_action: null, // name_updated/email_updated/birthday_updated/password_updated
    event_label: null, // name/email/birthday/password
  },
};

function trackAccountProfile(eventName: string, eventData: IDataLayer = {}) {
  eventData.event_action = eventData.profile_action?.toLowerCase() || '';
  eventData.event_label = eventData.profile_value?.toLowerCase() || '';

  tealium.evtLink({ ...defaultData[eventName], ...eventData });
}

Object.keys(defaultData).forEach((key) => {
  registerAnalyticsEventHandler(key, trackAccountProfile);
});
